import { Controller } from "stimulus";
import storage from "utils/storage";

export default class MenuSectionController extends Controller {
  static targets = ['section', 'toggleButton'];
  static values = {
    title: String,
    default: Boolean
  }

  connect() {
    // this.toggleCollapse();
    this.render();
  }

  toggleCollapse() {
    this.isCollapsed = !this.isCollapsed;
    this.render();
  }

  render() {
    this.sectionTarget.childNodes.forEach((node) => {
      if (node.nodeName === "LI") {
        if (this.isCollapsed) {
          node.classList.add("hidden");
        } else {
          node.classList.remove("hidden");
        }
      }
    })
    this.toggleButtonTarget.innerText = this.isCollapsed ? "▼" : "▲";
  }

  get isCollapsed() {
    return storage.get(this.storageKey, this.defaultValue);
  }

  set isCollapsed(value) {
    storage.set(this.storageKey, value);
  }

  get storageKey() {
    return `menu-section:${this.titleValue}`;
  }
}